import { z } from 'zod';
import { AnalyticsTimestampSchema } from '../timestamp.js';
const filterFlags = { is_negative: z.boolean().nullable().optional() };
const AnalyticsDateFilterValueSchema = z
    .union([AnalyticsTimestampSchema, z.string().regex(/^(?!\d{4}-\d{2}-\d{2}T)/)])
    .describe('Absolute datetime bounds use ISO 8601 with Z or an explicit offset and at most millisecond precision. Date-only values and relative expressions are also supported.');
/** Omni query predicates with ISO absolute datetime bounds translated by Primary before execution. */
const SimpleOmniFilterSchema = z.discriminatedUnion('type', [
    z.strictObject({
        type: z.literal('string'),
        kind: z.enum(['CONTAINS', 'ENDS_WITH', 'STARTS_WITH', 'EQUALS', 'IS_EMPTY', 'SQL_LIKE']),
        values: z.array(z.string()),
        case_insensitive: z.boolean().optional(),
        ...filterFlags,
    }),
    z.strictObject({
        type: z.literal('number'),
        kind: z.enum(['LESS_THAN', 'GREATER_THAN', 'EQUALS', 'BETWEEN']),
        values: z.array(z.union([z.string(), z.number()])),
        is_inclusive: z.boolean().optional(),
        ...filterFlags,
    }),
    z.strictObject({
        type: z.literal('date'),
        kind: z.enum([
            'IS_ON_DAY_OF_WEEK',
            'IS_ON_DAY_OF_QUARTER',
            'IS_IN_MONTH_OF_YEAR',
            'IS_ON_DAY_OF_YEAR',
            'IS_AT_HOUR_OF_DAY',
            'IS_IN_QUARTER_OF_YEAR',
            'IS_IN_WEEK_OF_YEAR',
            'IS_ON_DAY_OF_MONTH',
            'BETWEEN',
            'ON_OR_AFTER',
            'BEFORE',
            'TIME_FOR_INTERVAL_DURATION',
            'TIME_FOR_UNIT_DURATION',
            'QUERY_OFFSET',
        ]),
        left_side: AnalyticsDateFilterValueSchema.nullable().optional(),
        right_side: AnalyticsDateFilterValueSchema.nullable().optional(),
        offset_interval_string: z.string().nullable().optional(),
        isFiscal: z.boolean().optional(),
        ui_type: z
            .enum([
            'ANY_TIME',
            'BEFORE',
            'BETWEEN',
            'MONTH_OF_YEAR',
            'PAST',
            'YEAR',
            'DAY',
            'IS_ON_DAY_OF_WEEK',
            'ON_OR_AFTER',
            'IS_IN_THE_MONTH',
            'IS_IN_THE_QUARTER',
            'IS_IN_THE_FISCAL_QUARTER',
            'IS_IN_THE_FISCAL_YEAR',
            'TIME_FOR_INTERVAL_DURATION',
            'TIME_FOR_UNIT_DURATION',
            'CUSTOM',
        ])
            .nullable()
            .optional(),
        ...filterFlags,
    }),
    z.strictObject({ type: z.literal('null'), ...filterFlags }),
    z.strictObject({
        type: z.literal('boolean'),
        treat_nulls_as_false: z.boolean().optional(),
        ...filterFlags,
    }),
]);
export const OmniFilterSchema = z.lazy(() => z.union([
    SimpleOmniFilterSchema,
    z.strictObject({
        type: z.literal('composite'),
        conjunction: z.enum(['OR', 'AND']),
        filters: z.array(OmniFilterSchema).min(1),
        ...filterFlags,
    }),
]));
//# sourceMappingURL=filters.js.map